import React, {useContext, useEffect, Suspense, lazy} from 'react'
import { Routes, Route} from 'react-router-dom'
import RootContext from '../context/RootContext'
import Loader from '../components/Loader/Loader'
import FrontendLayout from '../components/FrontendLayout'
import Home from '../pages/Home'
import PDFView from '../components/PDF/PDFView'
import Checkout from '../pages/Checkout'
import ScrollToTop from '../components/ScrollToTop'
import ProductDetailsLayout from '../components/Layouts/ProductDetailsLayout'
import OrderTracking from '../pages/OrderTracking'
import ReturnExchange from '../pages/ReturnExchange'
import ComplaintBox from '../pages/ComplainBox'
import StoreLocator from '../pages/StoreLocator'
import PaymentPlans from '../pages/PaymentPlans'
import EarnRewards from '../pages/EarnRewards'
import ProductFilterPage from '../pages/ProductFilterPage'

const Contact = lazy( () => import('../pages/Contact'))
const Error404 = lazy( () => import('../pages/Error404'))

const AppRoutes = () => {
  const {loading, setLoading } =  useContext(RootContext)
  useEffect( () => {
    setLoading(false);
  },[setLoading])

  return loading ? <Loader /> : (
    <Suspense fallback={<Loader />}>
      <ScrollToTop>
        <Routes>
          <Route path="/*" element={<FrontendLayout />}>
              <Route index element={<Home />}/>
              <Route path="product-details/:slugToProduct" element={<ProductDetailsLayout />}/>
              
              <Route path="all-products" element={<ProductFilterPage />}/>

              <Route path="checkout" element={<Checkout />}/>
              <Route path="order-tracking" element={<OrderTracking />}/>

              <Route path="return-exchange" element={<ReturnExchange />}/>
              <Route path="complain-box" element={<ComplaintBox />}/>

              <Route path="earn-rewards" element={<EarnRewards />}/>
              <Route path="payment-plans" element={<PaymentPlans />}/>
              <Route path="store-locator" element={<StoreLocator />}/>

              <Route path="contact" element={<Contact />}/>
              <Route path="view-pdf/:id" element={<PDFView />}/>
              <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
      </ScrollToTop>
  </Suspense>
  )
}
export default AppRoutes